import { storableError } from '../../util/errors';

import { cancelSubscriptionAPI } from '../../util/api';

// ================ Action types ================ //

export const CANCEL_SUBSCRIPTION_PLAN_REQUEST =
  'app/SubscriptionDetailsPage/CANCEL_SUBSCRIPTION_PLAN_REQUEST';
export const CANCEL_SUBSCRIPTION_PLAN_SUCCESS =
  'app/SubscriptionDetailsPage/CANCEL_SUBSCRIPTION_PLAN_SUCCESS';
export const CANCEL_SUBSCRIPTION_PLAN_ERROR =
  'app/SubscriptionDetailsPage/CANCEL_SUBSCRIPTION_PLAN_ERROR';

// ================ Reducer ================ //

const initialState = {
  cancelPlanInProgress: false,
  cancelPlanError: null,
  cancelSubscriptionAtPeriodEnd: false,
};

export default function subscriptionDetailsPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case CANCEL_SUBSCRIPTION_PLAN_REQUEST: {
      return { ...state, cancelPlanInProgress: true, cancelPlanError: null };
    }
    case CANCEL_SUBSCRIPTION_PLAN_SUCCESS: {
      return { ...state, cancelPlanInProgress: false, cancelSubscriptionAtPeriodEnd: payload };
    }
    case CANCEL_SUBSCRIPTION_PLAN_ERROR: {
      return { ...state, cancelPlanInProgress: false, cancelPlanError: payload };
    }

    default:
      return state;
  }
}

// ================ Selectors ================ //

// ================ Action creators ================ //

export const cancelSubscriptionPlanRequest = () => ({
  type: CANCEL_SUBSCRIPTION_PLAN_REQUEST,
});

export const cancelSubscriptionPlanSuccess = payload => ({
  type: CANCEL_SUBSCRIPTION_PLAN_SUCCESS,
  payload,
});

export const cancelSubscriptionPlanError = e => ({
  type: CANCEL_SUBSCRIPTION_PLAN_ERROR,
  error: true,
  payload: e,
});

/* ================ Thunks ================ */

export const cancelSubscription = (subscriptionId, userId) => dispatch => {
  dispatch(cancelSubscriptionPlanRequest());

  return cancelSubscriptionAPI({ subscriptionId, userId })
    .then(response => {
      const updateSuccess = response.statusText === 'OK';
      dispatch(cancelSubscriptionPlanSuccess(updateSuccess));
    })
    .catch(e => {
      dispatch(cancelSubscriptionPlanError(storableError(e)));
      throw e;
    });
};
